import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["component", "elemBefore", "elemAfter", "shouldTitleWrap", "shouldDescriptionWrap"];
import React from 'react';
import ButtonItem from '@atlaskit/menu/button-item';
import CustomItem from '@atlaskit/menu/custom-item';
import LinkItem from '@atlaskit/menu/link-item';
import useRegisterItemWithFocusManager from './internal/hooks/use-register-item-with-focus-manager';

/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */
var DropdownMenuItem = function DropdownMenuItem(props) {
  var component = props.component,
      elemBefore = props.elemBefore,
      elemAfter = props.elemAfter,
      _props$shouldTitleWra = props.shouldTitleWrap,
      shouldTitleWrap = _props$shouldTitleWra === void 0 ? true : _props$shouldTitleWra,
      _props$shouldDescript = props.shouldDescriptionWrap,
      shouldDescriptionWrap = _props$shouldDescript === void 0 ? true : _props$shouldDescript,
      rest = _objectWithoutProperties(props, _excluded);

  var itemRef = useRegisterItemWithFocusManager();

  if (component) {
    return /*#__PURE__*/React.createElement(CustomItem, _extends({
      component: component,
      iconBefore: elemBefore,
      iconAfter: elemAfter,
      shouldTitleWrap: shouldTitleWrap,
      shouldDescriptionWrap: shouldDescriptionWrap
    }, rest));
  } else if (props.href) {
    return /*#__PURE__*/React.createElement(LinkItem, _extends({
      href: props.href,
      iconBefore: elemBefore,
      iconAfter: elemAfter,
      role: "menuitem",
      ref: itemRef,
      shouldTitleWrap: shouldTitleWrap,
      shouldDescriptionWrap: shouldDescriptionWrap
    }, rest));
  } else {
    return /*#__PURE__*/React.createElement(ButtonItem, _extends({
      role: "menuitem",
      iconBefore: elemBefore,
      iconAfter: elemAfter,
      ref: itemRef,
      shouldTitleWrap: shouldTitleWrap,
      shouldDescriptionWrap: shouldDescriptionWrap
    }, rest));
  }
};

export default DropdownMenuItem;